// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pindEntity from './entities/pind.json';
import pindMenu from '../pages/pind/menu.json';
import pindFullForm from '../pages/pind/forms/full.json';
import pindContextForm from '../pages/pind/forms/context.json';
import pindMiniForm from '../pages/pind/forms/mini.json';
import pindLookupForm from '../pages/pind/forms/lookup.json';
import pindTableView from '../pages/pind/views/table.json';
import pindStagesView from '../pages/pind/views/stages.json';
import pindCardsView from '../pages/pind/views/cards.json';
import pindInlineView from '../pages/pind/views/inline.json';
import pindBacklogView from '../pages/pind/views/backlog.json';
import pindSplitView from '../pages/pind/views/split.json';
import pindCalendarView from '../pages/pind/views/calendar.json';
import pindDashboardView from '../pages/pind/views/dashboard.json';

/** Тип запису «Показник» зі сторінками пакета: меню, форми та подання з pages/pind/. */
export const pindDefinition: IRecordTypeDefinition = {
  ...pindEntity,
  views: assembleViewSet({
      table: pindTableView,
      stages: pindStagesView,
      cards: pindCardsView,
      inline: pindInlineView,
      backlog: pindBacklogView,
      split: pindSplitView,
      calendar: pindCalendarView,
      dashboard: pindDashboardView,
  }),
  form: pindFullForm,
  forms: { full: pindFullForm, context: pindContextForm, mini: pindMiniForm, lookup: pindLookupForm },
  menu: pindMenu,
} as IRecordTypeDefinition;
